import { Reducer } from 'redux';
import { update } from '../../helpers/immutabilityHelper'
import * as Dtos from '../../dtos/Fig.dtos';

import {
    ACTION_SOURCEDOCUMENTSFORMS_LOAD,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_ID,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_ID,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_IDENTIFIER,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_SUCCESS,
    ACTION_SOURCEDOCUMENTSFORMS_LOAD_FAILURE,

    ACTION_SOURCEDOCUMENTSFORMS_SAVE,
    ACTION_SOURCEDOCUMENTSFORMS_SAVE_SUCCESS,
    ACTION_SOURCEDOCUMENTSFORMS_SAVE_FAILURE,

    ACTION_SOURCEDOCUMENTSFORMS_CREATE,
    ACTION_SOURCEDOCUMENTSFORMS_CREATE_SUCCESS,
    ACTION_SOURCEDOCUMENTSFORMS_CREATE_FAILURE,

    ACTION_SOURCEDOCUMENTSFORMS_CLEAR,
    SourceDocumentsFormAction
} from '../../actions/forms/sourceDocumentsForm';

import { RequestState } from "../../enumerations/RequestState";
import { IRequestState } from "../index";

export interface ISourceDocumentsFormState {
    formData: Dtos.SourceDocumentsForm | Dtos.SourceDocumentsForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[],
    loadState: IRequestState;
    saveState: IRequestState;
    createState: IRequestState;
}

const initialState: ISourceDocumentsFormState = {
    formData: undefined,
    formState: undefined,
    formProperties: undefined,
    lookups: undefined,
    loadState: {
        status: RequestState.None
    } as IRequestState,
    saveState: {
        status: RequestState.None
    } as IRequestState,
    createState: {
        status: RequestState.None
    } as IRequestState
};


function loading(state: ISourceDocumentsFormState, isLoading: boolean): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function loadSuccess(state: ISourceDocumentsFormState,
    formData: Dtos.SourceDocumentsForm | Dtos.SourceDocumentsForm[],
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[], responseStatus: Dtos.ResponseStatus
): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        loadState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function loadFailure(state: ISourceDocumentsFormState, responseStatus: Dtos.ResponseStatus): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        loadState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function saving(state: ISourceDocumentsFormState, isSaving: boolean): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function saveSuccess(
    state: ISourceDocumentsFormState,
    formData: Dtos.SourceDocumentsForm | Dtos.SourceDocumentsForm[],
    formState: Dtos.RegistrationFormState,
    responseStatus: Dtos.ResponseStatus
): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        saveState: {
            $set: {
                status: RequestState.Success,
                errorCode: responseStatus ? responseStatus.errorCode : undefined,
                errorMessage: responseStatus ? responseStatus.message : undefined,
                errors: responseStatus ? responseStatus.errors : undefined,
                meta: responseStatus ? responseStatus.meta : undefined
            } as IRequestState
        }
    });

    return newState;
}

function saveFailure(state: ISourceDocumentsFormState, responseStatus: Dtos.ResponseStatus): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        saveState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors,
                meta: responseStatus.meta
            } as IRequestState
        }
    });

    return newState;
}

function creating(state: ISourceDocumentsFormState, isCreating: boolean): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Pending
            } as IRequestState
        }
    });

    return newState;
}

function createSuccess(
    state: ISourceDocumentsFormState,
    formData: Dtos.SourceDocumentsForm,
    formState: Dtos.RegistrationFormState,
    formProperties: Dtos.RegistrationFormProperty[],
    lookups: Dtos.Lookup[]
): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        formData: {
            $set: formData
        },
        formState: {
            $set: formState
        },
        formProperties: {
            $set: formProperties
        },
        lookups: {
            $set: lookups
        },
        createState: {
            $set: {
                status: RequestState.Success
            } as IRequestState
        }
    });

    return newState;
}

function createFailure(state: ISourceDocumentsFormState, responseStatus: Dtos.ResponseStatus): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(state, {
        createState: {
            $set: {
                status: RequestState.Failure,
                errorCode: responseStatus.errorCode,
                errorMessage: responseStatus.message,
                errors: responseStatus.errors
            } as IRequestState
        }
    });

    return newState;
}

function clear(state: ISourceDocumentsFormState): ISourceDocumentsFormState {
    const newState: ISourceDocumentsFormState = update(initialState, {});

    return newState;
}

const SourceDocumentsFormReducer: Reducer<ISourceDocumentsFormState> = (state: ISourceDocumentsFormState = initialState, action: SourceDocumentsFormAction) => {
    switch (action.type) {
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD:
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_ID:
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_ID:
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD_BY_PATIENT_IDENTIFIER:
            return loading(state, true);
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD_SUCCESS:
            return loadSuccess(state, action.formData, action.formState, action.formProperties, action.lookups, action.responseStatus);
        case ACTION_SOURCEDOCUMENTSFORMS_LOAD_FAILURE:
            return loadFailure(state, action.responseStatus);
        case ACTION_SOURCEDOCUMENTSFORMS_SAVE:
            return saving(state, true);
        case ACTION_SOURCEDOCUMENTSFORMS_SAVE_SUCCESS:
            return saveSuccess(state, action.formData, action.formState, action.responseStatus);
        case ACTION_SOURCEDOCUMENTSFORMS_SAVE_FAILURE:
            return saveFailure(state, action.responseStatus);
        case ACTION_SOURCEDOCUMENTSFORMS_CREATE:
            return creating(state, true);
        case ACTION_SOURCEDOCUMENTSFORMS_CREATE_SUCCESS:
            return createSuccess(state, action.formData, action.formState, action.formProperties, action.lookups);
        case ACTION_SOURCEDOCUMENTSFORMS_CREATE_FAILURE:
            return createFailure(state, action.responseStatus);
        case ACTION_SOURCEDOCUMENTSFORMS_CLEAR:
            return clear(state);
    }

    return state;
}

export default SourceDocumentsFormReducer;